<template>
    <div class="mozali-login mozali-login--split mozali-login--recovery">
        <aside class="mozali-login__showcase">
            <div class="mozali-login__showcase-brand">
                <img
                    :src="urlGenerator('/logo_format_black.png')"
                    alt="Mozali"
                    class="mozali-login__showcase-logo"
                >
            </div>

            <div class="mozali-login__showcase-main">
                <div class="mozali-login__illustration-wrap">
                    <img
                        :src="urlGenerator('/images/shift-banner.svg')"
                        :alt="$t('forgot_password_illustration_alt')"
                        class="mozali-login__illustration"
                    >
                </div>
                <h2 class="mozali-login__showcase-title">
                    {{ $t('password_recovery_showcase_title') }}
                </h2>
                <p class="mozali-login__showcase-text">
                    {{ $t('password_recovery_showcase_text') }}
                </p>
            </div>

            <div class="mozali-login__testimonial">
                <p class="mozali-login__testimonial-title">{{ $t('password_recovery_hint_title') }}</p>
                <p class="mozali-login__testimonial-text">
                    {{ $t('password_recovery_hint_text') }}
                </p>
                <p class="mozali-login__testimonial-meta">{{ $t('password_recovery_hint_footer') }}</p>
            </div>
        </aside>

        <section class="mozali-login__auth-side">
            <form
                class="sign-in-sign-up-form mozali-login__form"
                ref="form"
                data-url="/user/password-reset"
                action="store"
            >
                <div class="mozali-login__brand text-center">
                    <img
                        :src="urlGenerator('/logo_format_black.png')"
                        alt="Mozali"
                        class="mozali-login__logo"
                    >
                </div>

                <p class="mozali-login__eyebrow">{{ $t('password_recovery_eyebrow') }}</p>
                <h3 class="mozali-login__title">{{ $t('password_recovery_title') }}</h3>
                <p class="mozali-login__support text-center">
                    {{ $t('enter_email_to_reset_password') }}
                </p>

                <div class="form-row">
                    <div class="form-group col-12 px-0">
                        <label for="reset_email">{{ $t('email') }}</label>
                        <app-input
                            id="reset_email"
                            type="email"
                            v-model="reset.email"
                            :placeholder="$t('enter_your_email')"
                            :required="true"
                        />
                    </div>
                </div>

                <div class="form-row">
                    <div class="form-group col-12 px-0 mb-2">
                        <app-load-more
                            :preloader="preloader"
                            :label="$t('send_reset_link')"
                            :class="{'disabled': userId}"
                            type="submit"
                            class-name="btn btn-primary btn-block text-center mozali-login__submit"
                            @submit="submit"
                        />
                    </div>
                </div>

                <div class="form-row">
                    <div class="col-12 px-0">
                        <p class="mozali-login__secondary text-center">
                            <span>{{ $t('remember_password') }}</span>
                            <a
                                :href="urlGenerator('/admin/users/login')"
                                class="mozali-login__forgot mozali-login__forgot--inline"
                            >
                                {{ $t('back_to_login') }}
                            </a>
                        </p>
                    </div>
                </div>

                <div class="form-row">
                    <div class="col-12 px-0">
                        <p class="mozali-login__copy text-center">
                            &copy; {{ currentYear }} -
                            <a
                                :href="mozaliSiteUrl"
                                class="mozali-login__copy-link"
                                target="_blank"
                                rel="noopener noreferrer"
                            >
                                www.mozali.com
                            </a>
                        </p>
                    </div>
                </div>
            </form>
        </section>
    </div>
</template>

<script>
    import ThemeMixin from "../../../../core/mixins/global/ThemeMixin";
    import {AuthMixin} from "./Mixins/AuthMixin";
    import {urlGenerator} from "../../../Helpers/AxiosHelper";

    export default {
        name: "PasswordReset",
        props: {
            userId: {}
        },
        mixins: [AuthMixin, ThemeMixin],
        data() {
          return {
              urlGenerator,
              mozaliSiteUrl: 'https://www.mozali.com',
              reset: {},
          }
        },
        computed: {
            currentYear() {
                return new Date().getFullYear();
            }
        },
        methods: {
            submit() {
                this.save(this.reset);
            },
            afterSuccess(res) {
                this.$toastr.s(res.data.message);
            },
        }
    }
</script>
